<template>
    <v-model.login.setup v-slot="{ model, loading, isError, starting, startFailed, start, canSubmit }">
        <div class="hgroup">
            <h1 class="card-title">Weryfikacja dwuetapowa</h1>
            <span class="card-subtitle">Skonfiguruj aplikację Google Authenticator lub Microsoft Authenticator</span>
        </div>

        <div v-if="isError && !loading" class="alert alert-danger vert-middle" role="alert">
            <v-icon icon="close-fill fs-4"/> Nieprawidłowy kod weryfikacyjny
        </div>

        <div v-if="startFailed" class="alert alert-danger vert-middle" role="alert">
            <v-icon icon="close-fill fs-4"/> Nie udało się rozpocząć konfiguracji
        </div>

        <div v-if="starting" class="text-center py-4">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Ładowanie</span>
            </div>
        </div>

        <template v-else-if="setup">
            <p class="small">
                Otwórz aplikację, dodaj nowe konto przyciskiem (+) i zeskanuj poniższy kod QR.
            </p>
            <div class="text-center mb-2">
                <img :src="setup.qr_code_svg" alt="Kod QR" class="img-fluid" style="max-width: 200px">
            </div>
            <p v-if="setup.secret" class="small text-muted text-center text-break">
                Klucz do wpisania ręcznie: <strong>{{ setup.secret }}</strong>
            </p>

            <div v-if="$auth.flow.recoveryCode" class="alert alert-warning text-center" role="alert">
                Zapisz kod odzyskiwania w bezpiecznym miejscu
                <div class="fs-4 fw-bold mt-1">{{ $auth.flow.recoveryCode }}</div>
            </div>

            <v-control-code v-model="model.code" label="Kod weryfikacyjny z aplikacji"/>

            <v-button :loading="loading" :submit="true" class="w-100" color="primary" label="Potwierdź"
                      :disabled="!canSubmit() || loading"/>
        </template>

        <v-button v-else-if="startFailed" class="w-100" color="primary" icon="refresh" label="Spróbuj ponownie"
                  @click="start"/>

        <v-button class="w-100 mt-2" color="secondary" :outline="true" icon="arrow-left-s" label="Wróć do logowania"
                  @click="$auth.cancelLogin()"/>
    </v-model.login.setup>
</template>

<script>
export default {
    name: "v-auth-two-factor-setup",
    computed: {
        setup() {
            return this.$auth.flow.setup;
        }
    }
}
</script>
